import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Spin } from 'antd';
import FileLoaderService from '../services/file-loader-service';

const FileName = ( props ) => {
    const { fileId, className, auth } = props;

    const [ file, setFile ] = useState( null );

    useEffect( () => {
        if ( !fileId ) {
            return;
        }
        const loadFile = async () => {
            try {
                const fileLoader = FileLoaderService( auth.state );
                const nextFile = await fileLoader.getFile( fileId );
                setFile( nextFile );
            } catch ( error ) {
                console.error( 'Error fetching file', error.status );
                setFile( null );
            }
        };
        loadFile();
    }, [ fileId, auth?.state?.claims?.company_id ] );

    return (
        <span className={ classNames( 'file-name', className ) } style={ file ? undefined : { display: 'inline-flex' } }>
            { file ?
                <span>{ file.name }</span>
                :
                <Spin size="small" data-testid="file-name-spin" />
            }
        </span>
    );
};

export default FileName;